<template>
  <div>

    <div class="mobile">
      <v-container fluid>
        <v-container fluid>

          <div v-if="foodCategories.length === 0 && drinkCategories.length === 0">
            <div class="text-center">
              <h3>Das Sortiment ist zur Zeit deaktiviert</h3>
              <div>Versuche es zu einem späteren Zeitpunkt erneut</div>
              <div class="spacer-25"></div>
              <MyLieferzeiten v-if="$store.getters.deliveryOrderingEnabled"></MyLieferzeiten>
              <MyAbholzeiten v-if="$store.getters.takeawayOrderingEnabled"></MyAbholzeiten>
            </div>
            <!--                        &lt;!&ndash;                    <div class="d-flex">&ndash;&gt;-->
            <!--                        <v-skeleton-loader-->
            <!--                                class="mx-auto maxw mt-2"-->
            <!--                                type="list-item"-->
            <!--                        ></v-skeleton-loader>-->
            <!--                        <v-skeleton-loader-->
            <!--                                class="mx-auto maxw mt-2"-->
            <!--                                type="list-item"-->
            <!--                        ></v-skeleton-loader>-->
            <!--                        <v-skeleton-loader-->
            <!--                                class="mx-auto maxw mt-2"-->
            <!--                                type="list-item"-->
            <!--                        ></v-skeleton-loader>-->
            <!--                        &lt;!&ndash;                    </div>&ndash;&gt;-->
          </div>


          <v-layout row wrap v-else>
            <v-flex xs12 md6 lg4 v-for="cat in foodCategories" :key="cat.id">
              <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat, false)"
                            :category="cat"></CategoryCard>
            </v-flex>
            <v-flex xs12 md6 lg4 v-for="cat in drinkCategories" :key="cat.id">
              <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat, true)"
                            :category="cat"></CategoryCard>
            </v-flex>
          </v-layout>

        </v-container>
      </v-container>
    </div>

    <div class="tablet">
      <v-container grid-list-lg>

        <div v-if="foodCategories.length === 0">
          <div class="text-center">
            <h3>Das Sortiment ist zur Zeit deaktiviert</h3>
            <div>Versuche es zu einem späteren Zeitpunkt</div>
          </div>
          <!--                    <div class="d-flex">-->
          <!--                        <v-skeleton-loader-->
          <!--                                class="mx-auto maxw"-->
          <!--                                max-width="360"-->
          <!--                                type="card"-->
          <!--                        ></v-skeleton-loader>-->
          <!--                        <v-skeleton-loader-->
          <!--                                class="mx-auto maxw"-->
          <!--                                max-width="360"-->
          <!--                                type="card"-->
          <!--                        ></v-skeleton-loader>-->
          <!--                        <v-skeleton-loader-->
          <!--                                class="mx-auto maxw"-->
          <!--                                max-width="360"-->
          <!--                                type="card"-->
          <!--                        ></v-skeleton-loader>-->
          <!--                    </div>-->
        </div>


        <v-layout row wrap v-else>
          <v-flex xs12 md6 lg4 v-for="cat in foodCategories" :key="cat.id">
            <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat)"
                          :category="cat"></CategoryCard>
          </v-flex>
          <v-flex xs12 md6 lg4 v-for="cat in drinkCategories" :key="cat.id">
            <CategoryCard class="pointer" @click.native.passive="gotoCategory(cat, true)"
                          :category="cat"></CategoryCard>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

  </div>

</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as qconst from '../vendor/qconstants';
import * as util from '../vendor/util'
// import {offerMixin} from "../mixins/offerMixin";
import CategoryCard from "../components/CategoryCard";
import MyAbholzeiten from "@/components/MyAbholzeiten.vue";
import MyLieferzeiten from "@/components/MyLieferzeiten.vue";
// import GotoDrinksCard from "./GotoDrinksCard";

export default {
  components: {
    MyLieferzeiten,
    MyAbholzeiten,
    CategoryCard
  },
  // mixins: [offerMixin],
  computed: {
    foodCategories() {
      let list = store.getters.foodMenu;
      console.log('foodCategories updated in UI. render categories: '+list.map(cat=>cat.categoryDE));
      return list;
    },
    drinkCategories() {
      let list = store.getters.drinkMenu;
      return list;
    },
  },
  created() {
    // ebus.$on('refreshCategories', () => {
    //     this.init();
    // });
    // ebus.$on(qconst.notify$foodsUpdated, () => {
    //   this.init();
    // });
    // ebus.$on(qconst.notify$drinksUpdated, () => {
    //     this.init();
    // });
  },
  destroyed() {
    util.clearEvents([
      qconst.notify$foodsUpdated,
      qconst.notify$drinksUpdated,
    ]);
  },
  mounted() {
    // this.init();
  },
  // activated() {
  //     this.init();
  // },
  methods: {
    // init() {
    //   let foodCats = util.cloneMe(store.getters.foodMenu);
    //   let relevantF = [];
    //   for (let fcat of foodCats) {
    //     if (!fcat.items) {
    //       continue;
    //     }
    //     relevantF.push(fcat);
    //     // for (let item of fcat.items) {
    //     //     let offerAndItem = store.getters.getOfferByItemId(item.id);
    //     //     // item.offered = !!offerAndItem;
    //     //     // if (!!offerAndItem) {
    //     //     //     item.offerId = offerAndItem.offer.id;
    //     //     // }
    //     //     this.applyOfferAndPrices(item, offerAndItem);
    //     // }
    // }
    //   this.foodCategories = relevantF;
    //
    //   //drinks
    //   let drinkCats = util.cloneMe(store.getters.drinkMenu);
    //   let relevantD = [];
    //   for (let dcat of drinkCats) {
    //     if (!dcat.items) {
    //       continue;
    //     }
    //     relevantD.push(dcat);
    //     // for (let item of fcat.items) {
    //     //     let offerAndItem = store.getters.getOfferByItemId(item.id);
    //     //     // item.offered = !!offerAndItem;
    //     //     // if (!!offerAndItem) {
    //     //     //     item.offerId = offerAndItem.offer.id;
    //     //     // }
    //     //     this.applyOfferAndPrices(item, offerAndItem);
    //     // }
    // }
    //   this.drinkCategories = relevantD;
    // },
    gotoCategory(cat, forDrinks) {
      console.log('!!!!! gotoCategory');
      // store.commit('selectedCategoryId', cat.id);
      // store.state.shouldJump = true;
      setTimeout(() => {
        util.jumpToTop();
      }, 160);
      if (forDrinks) {
        if (!store.getters.isKiosk && cat.items.length === 1 && !cat.items[0].section) {
          ebus.$emit('goto', {name: 'Getraenk', params: {itemId: cat.items[0].id}, scrollTarget: ''});
          // this.gotoItem(this.productsOfCategory[0]);
        } else {
          this.$router.push({name: 'GetraenkeProdukte', params: {catname: cat.categoryDE}});
        }
      } else {
        if (!store.getters.isKiosk && cat.items.length === 1 && !cat.items[0].section) {
          ebus.$emit('goto', {name: 'Speise', params: {itemId: cat.items[0].id}, scrollTarget: ''});
          // this.gotoItem(this.productsOfCategory[0]);
        } else {
          this.$router.push({name: 'SpeisenProdukte', params: {catname: cat.categoryDE}});
        }
      }
    },
  }


}
</script>

<style scoped lang="scss">

/*.loader ::v-deep .v-skeleton-loader{*/
/*    width: 100%;*/
/*}*/

</style>
